import { createAction } from '@reduxjs/toolkit';
import { UserMessage } from 'api/conversations';
import { slice } from './slices';
import { CommentActionPayload, ConversationContext } from './types';

export type ConversationSagaPayload = {
  context: ConversationContext;
};
export const getConversationAction = createAction<
  ConversationSagaPayload & {
    projectId: number;
  }
>('@@conversations/getConversationAction');

export const createCommentAction = createAction<
  CommentActionPayload<Partial<UserMessage>>
>('@@conversations/createCommentAction');

export const updateCommentAction = createAction<
  CommentActionPayload<UserMessage>
>('@@conversations/updateCommentAction');

export const deleteCommentAction = createAction<
  ConversationSagaPayload & { comment: Partial<UserMessage> }
>('@@conversations/deleteCommentAction');

export const { getAllComments, updateLastSeen } = slice.actions;
